var _g, _g2, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 775,
    height: 775,
    viewBox: "0 0 775 775",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_862_373)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 387.5,
    cy: 387.5,
    r: 232.5,
    fill: "url(#paint0_linear_862_373)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_iii_862_373)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.239,
    cy: 397.458,
    rx: 147.03,
    ry: 147.03,
    transform: "rotate(97.1786 403.239 397.458)",
    fill: "url(#paint1_linear_862_373)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.167 371.802L343.721 396.977L357.251 421.545L348.755 436.261L327.269 397.38L350.313 357.468L358.167 371.802ZM372.679 346.667L364.222 361.314L356.365 346.967L364.822 332.32L381.175 331.951L389.091 346.332L372.679 346.667ZM406.46 356.36L422.813 355.991L430.729 370.372L414.317 370.707L406.46 356.36Z",
    fill: "#BF962E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.125 396.509L362.671 381.706L371.282 396.546L362.775 411.28L354.125 396.509ZM362.862 432.467L371.472 447.307L388.693 447.381L380.186 462.115L362.966 462.041L354.355 447.201L362.862 432.467ZM451 382.134L468.158 382.171L476.831 397.047L468.325 411.781L451.104 411.708L459.611 396.974L451 382.134ZM430.415 447.543L445.084 422.299L462.241 422.336L439.061 462.485L392.459 462.213L401.005 447.41L430.415 447.543Z",
    fill: "#BF962E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M427.07 437.593L410.107 436.532L417.706 423.371L434.704 424.37L427.07 437.593Z",
    fill: "#BF962E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M450.32 397.153L441.846 411.999L411.617 411.404L396.982 436.752L379.433 436.397L370.351 421.376L384.985 396.029L369.356 370.147L377.903 355.343L395.549 355.662L411.005 381.524L441.269 382.058L450.377 397.186L450.32 397.153ZM392.489 330.059L440.242 330.903L464.914 371.874L447.325 371.588L431.731 345.645L401.531 345.149L392.489 330.059Z",
    fill: "#BF962E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_862_373",
    x: 0.771118,
    y: 0.771118,
    width: 773.458,
    height: 773.458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 77.1144,
    result: "effect1_foregroundBlur_862_373"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iii_862_373",
    x: 216.414,
    y: 193.586,
    width: 333.87,
    height: 373.648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -39.7785,
    dy: -56.8264
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 45.4714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.75 0 0 0 0 0.624971 0 0 0 0 0.596875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_862_373"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.7306
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.7073
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.866667 0 0 0 0 0.333333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_862_373",
    result: "effect2_innerShadow_862_373"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.6244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_862_373",
    result: "effect3_innerShadow_862_373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_373",
    x1: 387.5,
    y1: 155,
    x2: 387.5,
    y2: 620,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5D29",
    stopOpacity: 0.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_862_373",
    x1: 266.219,
    y1: 340.523,
    x2: 439.527,
    y2: 413.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#584D22"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.5ded5d663b411dea34406849d73b5151.svg";
export { ForwardRef as ReactComponent };